import { Box, Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getRewardsConfig } from "../../services/rewards.service";
import { Loading } from "../../components/Loading";
import { ErrorPageDetails } from "../../components/ErrorPageDetails";
import AppOpenedStreakBlock from "./AppOpenedStreakBlock";
import ShowsHostedBlock from "./ShowsHostedBlock";

const RewardsConfig = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["rewards-config"],
    queryFn: getRewardsConfig,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <ErrorPageDetails text="Error loading rewards config" />;
  }

  return (
    <Box>
      <Button
        startIcon={<ArrowBackIcon />}
        component={Link}
        to="/rewards"
        sx={{ mb: 2 }}
      >
        Back to rewards
      </Button>

      <AppOpenedStreakBlock
        config={data?.appOpenedStreak}
        onSuccess={refetch}
      />
      <ShowsHostedBlock config={data?.showsHosted} onSuccess={refetch} />
    </Box>
  );
};

export default RewardsConfig;
